module.exports = __webpack_public_path__ + "img/item2.27618a93.jpg";